import React from "react";

import { Box, Checkbox, Flex, Grid, GridItem, Image, Text } from "@chakra-ui/react";

import { BarAndValue } from "common/components/BarAndValue";
import { ADIF_RED, ESTADO_COMUNICACION_CONFIG } from "common/components/EstadoComunicacionIndicator";
import { actions as portfolioActions } from "store/portfolio/reducer";
import { useAppDispatch, useAppSelector } from "store/store";

export const PortfolioStatsComunicaciones: React.FC = () => {
	const dispatch = useAppDispatch();
	const portfolioStats = useAppSelector((state) => state.portfolio.portfolioStats.data);
	const comunicacionesPendientes = useAppSelector((state) => state.portfolio.comunicacionesPendientes);
	const filterSelection = useAppSelector((state) => state.portfolio.filterSelection);
	const pendienteParaMi = filterSelection?.pendienteParaMi === true;
	const handlePendienteParaMiChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(
			portfolioActions.setFilterSelection({
				...(filterSelection ?? {}),
				pendienteParaMi: e.target.checked ? true : undefined,
			}),
		);
	};
	const totalValue =
		(portfolioStats?.estado_comunicacion &&
			Object.values(portfolioStats.estado_comunicacion).reduce((a, b) => a + b, 0)) ||
		0;

	return (
		<Box pr="3rem" flex="1">
			<Grid templateColumns="1fr 4fr" alignItems="center" gap="0 0.5rem">
				{portfolioStats &&
					Object.entries(portfolioStats.estado_comunicacion).map(([key, value]) => {
						const config = ESTADO_COMUNICACION_CONFIG[key.toLowerCase()];
						return (
							<React.Fragment key={key}>
								<GridItem>
									<Flex alignItems="center" gap="0.375rem">
										{config?.icon && <Image src={config.icon} alt={key} boxSize="1rem" />}
										<Text textStyle="body3" color="gray.800">
											{config?.label ?? key}
										</Text>
									</Flex>
								</GridItem>
								<GridItem>
									<BarAndValue
										value={value}
										totalValue={totalValue}
										label={key}
										colors={{
											Enviada: "#E2E8F0",
											Vista: "#43B3EA",
											Contestada: "#A76BC7",
											Aprobada: "#32A4A0",
										}}
									/>
								</GridItem>
							</React.Fragment>
						);
					})}
			</Grid>
			{(comunicacionesPendientes > 0 || pendienteParaMi) && (
				<Checkbox
					colorScheme="gray"
					size="sm"
					mt=".5rem"
					isChecked={pendienteParaMi}
					onChange={handlePendienteParaMiChange}
				>
					<Text textStyle="body3" color={ADIF_RED} fontWeight="bold">
						{comunicacionesPendientes === 1
							? "Tienes 1 mensaje pendiente"
							: `Tienes ${comunicacionesPendientes} mensajes pendientes`}
					</Text>
				</Checkbox>
			)}
		</Box>
	);
};
